export var ButtonType;
(function (ButtonType) {
    ButtonType["primary"] = "primary";
    ButtonType["secondary"] = "secondary";
    ButtonType["tertiary"] = "tertiary";
    ButtonType["contextual"] = "contextual";
})(ButtonType || (ButtonType = {}));
export var ButtonColor;
(function (ButtonColor) {
    ButtonColor["primary"] = "primary";
    ButtonColor["dark"] = "dark";
    ButtonColor["bright"] = "bright";
})(ButtonColor || (ButtonColor = {}));
//# sourceMappingURL=types.js.map